import { css } from '@emotion/react';

import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.brief-module': {
    display: 'flex',
    padding: '32px 16px',
    flexDirection: 'column',
    alignItems: 'flex-end',
    alignSelf: 'stretch',
  },
  '.brief-module': {
    '&__heading p': {
      color: COLORS.NEUTRAL800,
      fontWeight: 600,
      fontSize: theme.fontSizes[5],
    },
    '&__heading--sm p': {
      color: COLORS.NEUTRAL800,
      fontSize: theme.fontSizes[3],
    },
    '&__scene-wrapper': {
      justifyContent: 'space-around',
      flexWrap: 'wrap',
      gap: '20px',
    },
    '&__thumbnail': {
      maxWidth: '8rem',
      marginRight: theme.space[3],
      borderRadius: '5.761px',
    },
    '&__file-name': {
      marginBottom: 0,
    },
    '&__file': {
      alignItems: 'start',
      flexDirection: 'column',
    },
    '&__section': {
      marginBottom: theme.space[6],
    },
    '&__section--mt': {
      marginTop: theme.space[4],
    },
    '&__aspect-ratio': {
      flexDirection: 'column',
      gap: '8px',
      marginTop: '12px',
      '&__option': {
        svg: {
          color: COLORS.PRIMARY300,
          marginRight: theme.space[2],
        },
        alignItems: 'center',
      },
    },
  },
});
